export const environment = {
  production: true,
  apiEndPoint: 'https://invoice-api.taskopad.com/api',
  apiMediaEndPoint: 'https://invoice-api.taskopad.com',
  taskopadEndpoint: 'https://bff.taskopad.com',
  taskopadAuthToken:"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MzcsImVtYWlsIjoidGFza29wYWRBZG1pbkB0YXNrb3BhZC5jb20iLCJmaXJzdF9uYW1lIjoiVGFza29wYWQiLCJsYXN0X25hbWUiOiJBZG1pbiIsImlhdCI6MTY5NjMxMzE4MCwiZXhwIjoxNzI3ODcwNzgwfQ.w2VlaDg3temS5CAg63VFEoz_AxLIKsR1bzl0OMUbZNY",
  taskopadSecretKey:"W1lIjoiVGFza29wYWQiLCJs@2469%yrertwqy",
  notificationBaseURL:'https://notification.taskopad.com'
};
